import { render, staticRenderFns } from "./FolderDetail.vue?vue&type=template&id=6e3e7264"
import script from "./FolderDetail.vue?vue&type=script&lang=js"
export * from "./FolderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports